import API from '@/js/API'
window.API = API;

//引入axios
import '@/js/lib/request'

Vue.prototype.$message = ELEMENT.Message
Vue.prototype.$MessageBox = ELEMENT.MessageBox

Vue.prototype.bus = new Vue();

//引入swiper
import AwesomeSwiper from 'vue-awesome-swiper'
window.AwesomeSwiper = AwesomeSwiper;
Vue.use(AwesomeSwiper);

//引入i18n国际化插件
import { i18n } from '@/locales/index';
window.i18n = i18n;

//引入jqueery
Vue.prototype.$ = window.Jq = $


//引入懒加载
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/optimumx/ls.optimumx';
import 'lazysizes/plugins/attrchange/ls.attrchange';

window.lazySizesConfig = lazySizes.cfg || {};
window.lazySizesConfig.constrainPixelDensity = true;

//引入社交分享
var SocialSharing = require('vue-social-sharing');
window.Vue.use(SocialSharing);



import store from '@/js/store/index'
window.store = store;

Vue.component('v-app', require('@/js/App.vue').default);
Vue.component('v-back-top', require('@/js/components/BackTop.vue').default);
Vue.component('v-product', require('./view/product/index.vue').default);
// Vue.component('v-search', require('./view/search/index.vue'));.default
Vue.component('v-collections', require('./view/collections/index.vue').default);
Vue.component('v-product-list', require('./view/productlist/index.vue').default);
Vue.component('v-count-down', require('../js/common/countdown.vue').default);
Vue.component('v-product-card', require('../../venue/js/view/collections/ProductCard.vue').default);
Vue.component('v-collections-card', require('./view/collections/card.vue').default);
Vue.component('v-nav-bar', require('./common/navbar.vue').default);
Vue.component('v-hot-banner', require('../js/common/hotBanner.vue').default);
Vue.component('v-hot-tabs', require('../js/common/hotTabs.vue').default);
Vue.component('v-mark', require('../../../js/components/view/mark/r_index.vue').default);
Vue.component('v-image-card', require('../../../js/components/view/mark/card.vue').default);
Vue.component('v-r-image-card', require('../../../js/components/view/mark/r_card.vue').default);
Vue.component('v-cart', require('./view/cart/index.vue').default);
Vue.component('v-search', require('./view/search/index.vue').default);
// 空组件
Vue.component('v-empty-component', require('../../../js/components/common/EmptyComponent.vue').default);

Vue.component('v-login', require('./view/login/index.vue').default);
Vue.component("v-register", require("./view/register/index.vue").default);
//Vue.component('v-accountbodyaddress', require('../../../js/components/view/account/accountbodyaddress.vue'));.default
//Vue.component('v-accountbodyorder', require('../../../js/components/view/account/accountbodyorder.vue'));.default

//个人中心
Vue.component('v-accountbody', require('./view/account/index.vue').default);
Vue.component('v-accounttop', require('./view/account/accounttop.vue').default);
//地址簿
Vue.component('v-accountbodyaddress', require('./view/account/accountbodyaddress.vue').default);
//订单详情
Vue.component('v-accountbodyorder', require('./view/account/accountbodyorder.vue').default);


Vue.component('v-comments-item-box', require('../../../js/components/view/comments/commentsItemBox.vue').default);
// Vue.component('v-comments-star', require('../../../js/components/view/comments/commentsstar.vue').default);

Vue.component('v-cartnum', require('../../venue/js/common/cartnum.vue').default);
Vue.component('v-popupcart', require('../../venue/js/common/popupcart.vue').default);
// Vue.component('v-inputnum', require('../../venue/js/common/inputnum.vue').default);
// Vue.component('v-countdown', require('../../../js/components/common/countdown.vue').default);
Vue.component('v-selectprice', require('../../../js/components/common/selectprice.vue').default);
Vue.component('v-contactpage', require('../../../js/components/common/contactpage.vue').default);
// Vue.component('v-social-auth', require('../../../js/components/view/socialauth/index.vue').default);
//调色板
Vue.component('v-product-palette', require('../../../js/components/view/productpalette/index.vue').default);

// Vue.component('v-collections', require('./view/collection/index.vue'));.default
Vue.component('v-singlecommodity', require('../../../js/components/view/singlecommodity/index.vue').default);
// // 货币符号
Vue.component('v-currencysymbol', require('../../../js/components/common/currencysymbol.vue').default);
Vue.component("v-payicon", require("../../../js/components/common/payicon.vue").default);
Vue.component("v-selectlang", require("../../../js/components/common/selectlang.vue").default);

Vue.component("v-lastsales", require("../../../js/components/view/lastsales/lastsales.vue").default);
// Vue.component("v-codedisplay", require("../../../js/components/view/codedisplay/index.vue").default);
// 自定义按钮
Vue.component('v-custom-button', require('../../../js/components/view/customButton/index.vue').default);
//error 404
Vue.component("v-error404", require("./view/error/error404.vue").default);
// 翻译
Vue.component('v-translate', require('../../../js/components/common/translate.vue').default);
// 物流
Vue.component("v-track", require("../../../js/components/view/track/index.vue").default);
// 购物车备注
// Vue.component('v-cartnote', require('../../../js/components/common/cartnote.vue').default);
// dmca举报页面
Vue.component('v-dmcaform', require('../../../js/components/page/dmca_form.vue').default);
// popBox
// Vue.component('v-popbox', require('../../../js/components/common/popBox.vue').default);
// scrollText
// Vue.component('v-scrolltext', require('../../../js/components/common/scrollText.vue').default);
// inlinecart
Vue.component('v-inlinecart', require('../../../js/components/common/inlinecart.vue').default);
// inlinecart
Vue.component('v-drawerCartItem', require('../../../js/components/common/drawerCartItem.vue').default);
// productFilter
Vue.component('v-productFilter', require('../../../js/components/view/productFilter/index.vue').default);
// 推荐商品
// Vue.component('v-guess-like', require('../../../js/components/view/guesslike/guesslike').default);
// 图片放大镜
// Vue.component('v-picZoom', require('../../../js/components/common/picZoom.vue').default);
// 搜索框
Vue.component('v-search-input', require('../../../js/components/common/searchInput.vue').default);
// instragram
Vue.component('v-instagram', require('../../../js/components/view/instagram/instagram.vue').default);
// 通用图片卡
Vue.component('v-lazy-img', require('@/js/components/LazyImg.vue').default);

// 卡片加购按钮
Vue.component('v-addCardBtn', require('../../../js/components/common/addCardBtn.vue').default);
// 浏览记录
Vue.component('v-browsing-record', require('../../../js/components/view/browsingRecord/browsingRecord.vue').default);
//单纯价格组件
Vue.component('v-simplePrice', require('@/js/components/common/simplePrice.vue').default);
// 产品tag
// Vue.component('v-product-tag', require('@/js/components/view/productTag/productTag.vue').default);
// 图片热区
Vue.component('v-hot-zone', require('@/js/components/view/hotZone/index.vue').default);

// 首页博客模块
Vue.component('v-module-blog', require('@/js/views/Home/Modules/Blog.vue').default);
// 博客页面
Vue.component('v-blog', require('@/js/views/Blog/index.vue').default);
// 博客详情页
Vue.component('v-blog-detail', require('@/js/views/Blog/Detail.vue').default);
// 移动端加购弹窗
Vue.component('v-add-cart-popup', require('@/js/components/view/MobileAddCartPopup').default);
// 异常关闭页面
// Vue.component('v-page-close',  require('@/js/views/Errors/Close.vue').default);

//菜单栏气泡标签组件
Vue.component('v-menu-tag', require('@/js/components/common/menuTag.vue').default);
// 首页商品推售模块
Vue.component('v-good-sell', require('@/js/views/Home/Modules/GoodSell.vue').default);

//paypalBtn
Vue.component('v-paypal-btn', require('@/js/components/common/paypalBtn.vue').default);

// 隐私政策
Vue.component('v-privacy-policy',require('@/js/components/view/privacyPolicy/index.vue').default);
// 售卖特点
Vue.component('v-sellFeatures', require('@/js/components/common/sellFeatures.vue').default);

// 引入公用方法挂入vue
import METHODS from '../../../js/methods';
for (const key in METHODS) {
  if (METHODS.hasOwnProperty(key)) {
    Vue.prototype[key] = METHODS[key]
  }
  if (key == 'send_fb_event') {
    //默认像素事件
    METHODS[key]('PageView', {})
  }
}
import defaultImage from '@/images/vogue_df.png'
Vue.prototype.defaultImage = defaultImage

import googleAnalysis from '@/js/lib/ga';

if (process.env.MIX_SENTRY_DSN && process.env.MIX_VERSION) {
  import(/* webpackChunkName: "sentry" */ `@/sentry/index`)
}

// 保存配置到全局状态
const { commit } = store

commit({
  type: 'settings/save',
  payload: {
    defaultNoImage: defaultImage
  }
})

// 谷歌分析插件
if (window.onGoogleAnalysisLoad) {
  const googleAnalysisLoad = (trackId, Ecommerce) => {

    // 保存ga信息
    commit({
      type: 'googleAnalysis/save',
      payload: {
        enable: !!trackId,
        trackId: trackId,
        ecommerce: !!parseInt(Ecommerce || 0, 2),
      }
    })
  }

  window.onGoogleAnalysisLoad(googleAnalysisLoad)

  delete window.onGoogleAnalysisLoad

  // 默认追踪页面
  googleAnalysis.page()
}

new Vue({
  el: '#app',
  store,
  i18n,
})
